import { ButtonBase } from '@mui/material';

import { ChkHeader, ChkIconClose } from '@ui/checkout-components';

import { TEST_IDS } from '../../models/globals/testIds.constants';

import type { HeaderWithCloseButtonProps } from './HeaderWithCloseButton.types';

export function CloseButton({
  closeIconTestId,
  onClick,
  ...rest
}: Omit<HeaderWithCloseButtonProps, 'children'>) {
  if (onClick) {
    return (
      <ButtonBase
        data-testid={closeIconTestId ?? TEST_IDS.SCA_HEADER_CLOSE_BUTTON}
        disableRipple
        onClick={onClick}
        {...rest}
      >
        <ChkIconClose />
      </ButtonBase>
    );
  }

  return null;
}

export const HeaderWithCloseButton = ({
  children,
  ...buttonProps
}: HeaderWithCloseButtonProps) => {
  return (
    <ChkHeader componentEnd={<CloseButton {...buttonProps} />}>
      {children}
    </ChkHeader>
  );
};
